import { createApi } from '@reduxjs/toolkit/query/react';
import  baseQuery from '.';
import { UUID } from 'crypto';
import { handleGlobalSearch } from '@/utils';

export const adminsApi = createApi({
	reducerPath: 'adminsApi',
	tagTypes: ['admins'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getAdmins: builder.query({
			query: ({ page, filters }: { page: number; filters: any }) => ({
				url: `admins`,
				params: { page, ...handleGlobalSearch(filters, ['email']) },
			}),
			providesTags: ['admins'],
		}),
		deleteAdmin: builder.mutation({
			query: (id: UUID) => ({
				url: `admins/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['admins'],
		}),
		addAdmin: builder.mutation({
			query: ({ email, name, password }: { email: string; name: string; password: string }) => ({
				url: `admins`,
				method: 'POST',
				body: { email, name, password },
			}),
			invalidatesTags: ['admins'],
		}),
		updateAdmin: builder.mutation({
			query: ({ email, name, password, id }: { email: string; name: string; password: string; id: UUID }) => ({
				url: `admins/${id}`,
				method: 'PATCH',
				body: { name, email, password },
			}),
			invalidatesTags: ['admins'],
		}),
		resetAdminPassword: builder.mutation({
			query: ({ password, id }: { password: string; id: UUID }) => ({
				url: `admins/${id}/reset-password`,
				method: 'PATCH',
				body: { password },
			}),
			invalidatesTags: ['admins'],
		}),
		changePassword: builder.mutation({
			query: ({ oldPassword, newPassword }: { oldPassword: string; newPassword: string; }) => ({
				url: `admins/change-password`,
				method: 'PATCH',
				body: { oldPassword, newPassword },
			}),
			invalidatesTags: ['admins'],
		}),
	}),
});

export const {
	useAddAdminMutation,
	useDeleteAdminMutation,
	useGetAdminsQuery,
	useUpdateAdminMutation,
	useResetAdminPasswordMutation,
	useChangePasswordMutation
} = adminsApi;
